import { connect } from 'react-redux';
import {
  consumeNavigatorRestoration,
  deleteConditionsProjects,
  fetchConditionsProjects,
  renameConditionsProject,
  setConditionsAnnouncement,
  setConditionsPaging,
  setConditionsSelectedIds,
  setConditionsSort,
  setNavigatorRestoration,
} from './actions';
import ConditionsNavigator from './ConditionsNavigator';
import {
  getConditionsAnnouncement,
  getConditionsError,
  getConditionsIsLoading,
  getConditionsNavigatorRestoration,
  getConditionsPage,
  getConditionsPageSize,
  getConditionsProjectsHasSettledOnce,
  getConditionsRuns,
  getConditionsSelectedIds,
  getConditionsSort,
  getConditionsTotalItems,
  getConditionsTotalPages,
} from './selectors';

const mapStateToProps = (state) => ({
  runs: getConditionsRuns(state),
  sort: getConditionsSort(state),
  selectedIds: getConditionsSelectedIds(state),
  announcement: getConditionsAnnouncement(state),
  error: getConditionsError(state),
  isLoading: getConditionsIsLoading(state),
  projectsHasSettledOnce: getConditionsProjectsHasSettledOnce(state),
  page: getConditionsPage(state),
  pageSize: getConditionsPageSize(state),
  totalItems: getConditionsTotalItems(state),
  totalPages: getConditionsTotalPages(state),
  navigatorRestoration: getConditionsNavigatorRestoration(state),
});

const mapDispatchToProps = {
  fetchProjects: fetchConditionsProjects,
  setSort: setConditionsSort,
  setPaging: setConditionsPaging,
  setSelectedIds: setConditionsSelectedIds,
  setAnnouncement: setConditionsAnnouncement,
  renameProject: renameConditionsProject,
  deleteProjects: deleteConditionsProjects,
  setNavigatorRestoration,
  consumeNavigatorRestoration,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConditionsNavigator);
